export default __webpack_public_path__ + "static/media/uk-flag.55882f2c.svg";